import axios from 'axios';
import {BASE_URL} from '../constants/GlobalConstants'

class SongService {

    getVideoProduction(id){
        return axios.get(BASE_URL + "/videoProduction/" + id)
    }

    getPagedVideoProductions(options){
        let url = BASE_URL + "/videoProduction?page=" + options.page;
        url = (options.sortField && options.sortOrder) && (options.sortField !== '' && options.sortOrder !== '') ? `${url}&sort=${options.sortField},${options.sortOrder}` : `${url}&sort=id,asc`;
        return axios.get(url);
    }

    searchForVideoProductionsByType(videoProductionType, page, size){
        let url = BASE_URL + "/videoProduction?videoProductionType=" + videoProductionType + "&page=" + page;
        if(size) url += `&size=${size}`
        return axios.get(url);
    }

    postVideoProduction(formData){
        return axios.post(BASE_URL + "/videoProduction", formData);
    }

    putVideoProduction(song){
        return axios.put(BASE_URL + "/videoProduction", song);
    }

    deleteVideoProduction(songId){
        return axios.delete(BASE_URL + `/videoProduction/${songId}`);
    }

}

export default new SongService();